export default function updateChaynsId(): void {
    window.updateBadges();
}
